/**
 * Resume link from a signup reminder email (backend#901):
 * `/consultant-signup#resume=<token>`.
 *
 * The token sits in the URL fragment, which is never sent to a server. It is
 * captured and removed from the address bar when the app boots (`main.tsx`
 * imports this module first), before analytics or anything else can read the
 * URL, and kept in memory for the signup wizard to exchange.
 */
export const RESUME_TOKEN_PARAM = "resume";
const SIGNUP_PATH = "/consultant-signup";

let captured: string | null = null;

/** Move a resume token from the address bar into memory. Idempotent. */
export const captureResumeToken = (): void => {
  try {
    if (window.location.pathname.replace(/\/+$/, "") !== SIGNUP_PATH) {
      return;
    }
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const token = params.get(RESUME_TOKEN_PARAM);
    if (!token) {
      return;
    }
    captured = token;
    params.delete(RESUME_TOKEN_PARAM);
    const rest = params.toString();
    const { pathname, search } = window.location;
    window.history.replaceState(
      window.history.state,
      "",
      pathname + search + (rest ? `#${rest}` : "")
    );
  } catch (error) {
    console.warn("Could not read the resume link:", error);
  }
};

/** The captured token, if the app was opened from a resume link. */
export const getCapturedResumeToken = (): string | null => captured;

/** Forget the token once it has been used, so a later visit starts normally. */
export const clearCapturedResumeToken = (): void => {
  captured = null;
};

captureResumeToken();
